import { isMobile } from '@/helpers/mobile_detect';

let swiper = null;

$(document).on('turbolinks:before-cache', () => {
  if (swiper) {
    swiper.destroy();
    swiper = null;
  }
});

$(document).on('turbolinks:load', async () => {
  if (
    !document.body.className.includes('v4') &&
      !document.body.className.includes('v3')
  ) { return; }

  const swiperNode = document.body.querySelector('article.boxes_with_slider .swiper-v8');
  if (!swiperNode) { return; }

  const [{ default: Swiper }, { Navigation }] = await Promise.all([
    import('swiper'),
    import('swiper/modules')
  ]);

  swiper = new Swiper(swiperNode, {
    grabCursor: true,
    wrapperClass: 'boxes',
    slideClass: 'box',
    slidesPerView: isMobile() ? 1 : 4,
    spaceBetween: 24,
    // modules: [Navigation, Pagination],
    modules: [Navigation],
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
      disabledClass: 'is-disabled'
    }
  });
  swiper.changeLanguageDirection(document.documentElement.getAttribute('dir'));
});
